import { Fragment, useState, useEffect } from 'react';
import { Button } from 'react-bootstrap';
import Select  from 'react-select';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import ToolkitProvider, { ColumnToggle, Search } from 'react-bootstrap-table2-toolkit';
import filterFactory, { multiSelectFilter, textFilter } from 'react-bootstrap-table2-filter';
import moment from 'moment';
import { useHistory  } from 'react-router-dom';
import "./GrievanceList.css"; 

const GrievanceList = ({ grievances }) => {
    
    const [grievancesCopy, setGrievancesCopy] = useState(grievances);
    const [grievancesCopyFromDate, setGrievancesCopyFromDate] = useState([]);
    const [grievancesCopyFromDate2, setGrievancesCopyFromDate2] = useState([]);
    const [grievancesCopyToDate, setGrievancesCopyToDate] = useState([]);
    const [grievancesCopyToDate2, setGrievancesCopyToDate2] = useState([]);
    const [defaultFromDate, setDefaultFromDate] = useState('');
    const [defaultToDate, setDefaultToDate] = useState('');
    const [changeFromDate, setChangeFromDate] = useState('');
    const [changeToDate, setChangeToDate] = useState('');
    const [defaultFromDateReady, setDefaultFromDateReady] = useState([]);
    const [fromDate, setfromDate] = useState(false);
    const [toDate, settoDate] = useState(false);
    let statusfilter; 
    let priorityfiltergrievance;
    let categoryfilter;

    const optionStatus = [
        { value: 'Open', label: 'Open' },
        { value: 'Validation', label: 'Validation' },
        { value: 'Closed', label: 'Closed' },
        { value: 'Rejected', label: 'Rejected' },
    ]

    const optionPriority = [
        { value: '1', label: 'Low' },
        { value: '2', label: 'Medium' },
        { value: '3', label: 'High' },
        { value: '4', label: 'Critical' },
        { value: '5', label: 'IR Critical' },
    ]

    const optionCategory = [
        { value: 'Canteen', label: 'Canteen' },
        { value: 'Hostel', label: 'Hostel' },
        { value: 'Transportation', label: 'Transportation' },
        { value: 'Work Issue', label: 'Work Issue' },
        { value: 'Wages & Benefits', label: 'Wages & Benefits' },
        { value: 'Security', label: 'Security' },
        { value: 'Sexual Harassment', label: 'Sexual Harassment' },
        { value: 'Bullying', label: 'Bullying' },
        { value: 'Safety', label: 'Safety' },
    ]

    const columns = [
        { 
            dataField: 'grievanceID', 
            text: 'Form ID', 
            sort: true,
            sortFunc: (a, b, order, dataField, rowA, rowB) => { 
                if (order === 'asc')
                {
                  return parseInt(a) - parseInt(b)
                }
               else if (order === 'desc') {
                  return  parseInt(b) - parseInt(a) 
                }
            },
            headerStyle: { textAlign: 'center' }, 
            style: { textAlign: 'center' , textDecoration: 'underline', cursor: 'pointer'},
            formatter: (cell, row) => `TGGRI_${moment(row.createdDate).format('MMYYYY')}_${row.grievanceID}`,
            csvFormatter: (cell, row) => `TGGRI_${moment(row.createdDate).format('MMYYYY')}_${row.grievanceID}`,
            headerAttrs: { width: 150 },
            attrs: { width: 150},
        },
        { 
            dataField: 'createdDate', 
            text: 'Request Date', 
            sort: true,
            headerStyle: { textAlign: 'center' }, 
            style: { textAlign: 'center', cursor: 'pointer' },
            formatter: (cell, row) => `${moment(row.createdDate).format('DD/MM/YYYY')}`,
            csvFormatter: (cell, row) => `${moment(row.createdDate).format('DD/MM/YYYY')}`,
            sortFunc: (a, b, order, dataField, rowA, rowB) => { 
                if (order === 'asc')
                {
                  return Date.parse(a) - Date.parse(b)
                }
               else if (order === 'desc') {
                  return  Date.parse(b) - Date.parse(a) 
                }
            },
            headerAttrs: { width: 120 },
            attrs: { width: 120},
        },
        { 
            dataField: 'createdByID', 
            text: 'Badge ID', 
            sort: true, 
            headerStyle: { textAlign: 'center' }, 
            style: { textAlign: 'center', cursor: 'pointer' },
            headerAttrs: { width: 120 },
            attrs: { width: 120},
        },
        { 
            dataField: 'createdByName', 
            text: 'Requestor Name', 
            sort: true, 
            headerStyle: { textAlign: 'center' }, 
            style: { textAlign: 'center', cursor: 'pointer', textTransform: 'capitalize' },
            formatter: (cell, row) => `${row.createdByName?.toLowerCase()}`,
            headerAttrs: { width: 200 },
            attrs: { width: 200},
        },
        { 
            dataField: 'userType', 
            text: 'Employee Type', 
            sort: true, 
            headerStyle: { textAlign: 'center' }, 
            style: { textAlign: 'center', cursor: 'pointer' },
            formatter: (cell,row) => {
                if(row.userType == 1){
                    return `Staff`
                }
                else if (row.userType == 2){
                    return `Worker`
                }
            },
            csvFormatter: (cell,row) => {
                if(row.userType == 1){
                    return `Staff`
                }
                else if (row.userType == 2){
                    return `Worker`
                }
            },
            headerAttrs: { width: 80 },
            attrs: { width: 80},
        },
        { 
            dataField: 'factory', 
            text: 'Factory', 
            sort: true, 
            headerStyle: { textAlign: 'center' }, 
            style: { textAlign: 'center', cursor: 'pointer' },
            headerAttrs: { width: 120 },
            attrs: { width: 120}, 
        },
        { 
            dataField: 'categoryName', 
            text: 'Grievance Category',
            sort: true,
            headerStyle: { textAlign: 'center' }, 
            style: { 
                textAlign: 'center',
                textTransform: 'capitalize', cursor: 'pointer'
            },
            headerAttrs: { width: 120 },
            attrs: { width: 120},
            filter: textFilter(),
            filterRenderer: (filter) => {
                categoryfilter = filter;
                return null;
            },
        },
        { 
            dataField: 'subcategoryName', 
            text: 'Grievance Sub Category',
            sort: true,
            headerStyle: { textAlign: 'center' }, 
            style: { 
                textAlign: 'center',
                textTransform: 'capitalize', cursor: 'pointer'
            },
            headerAttrs: { width: 120 },
            attrs: { width: 120},
        },
        { 
            dataField: 'priorityID',
            text: 'Severity', 
            headerStyle: { textAlign: 'center' }, 
            style: { 
                textAlign: 'center',
                textTransform: 'capitalize', cursor: 'pointer'
            },
            sort: true,
            formatter: (cell,row) => `${row.priorityName}`,
            csvFormatter: (cell,row) => `${row.priorityName}`,
            filter: textFilter(),
            filterRenderer: (filter) => {
                priorityfiltergrievance = filter;
                return null;
            },
            headerAttrs: { width: 80 },
            attrs: { width: 80},
        },
        { 
            dataField: 'issueName', 
            text: 'Issue',
            sort: true,
            headerStyle: { textAlign: 'center' }, 
            style: { 
                textAlign: 'center',
                textTransform: 'capitalize', cursor: 'pointer'
            },
            headerAttrs: { width: 120 },
            attrs: { width: 120},
        },
        { 
            dataField: 'remark', 
            text: 'Remark', 
            sort: true,
            headerStyle: { textAlign: 'center' }, 
            style: { textAlign: 'center', cursor: 'pointer', wordBreak: 'break-word' },
            headerAttrs: { width: 200 },
            attrs: { width: 200},
        },
        { 
            dataField: 'actionRemark', 
            text: 'Final Action Taken', 
            sort: true,
            headerStyle: { textAlign: 'center' }, 
            style: { textAlign: 'center', cursor: 'pointer', wordBreak: 'break-word'},
            headerAttrs: { width: 200 },
            attrs: { width: 200},
        },
        { 
            dataField: 'fhrPIC', 
            text: 'Action By', 
            sort: true,
            headerStyle: { textAlign: 'center' }, 
            style: { textAlign: 'center' },
            formatter: (cell,row) => {
                if(row.fhrPIC && row.grievancePIC){
                    if(row.grievanceStatusID == 2){
                        return `FHR: ${row.fhrPIC}`
                    }
                    else if(row.grievanceStatusID == 4){
                        return `PIC: ${row.grievancePIC}`
                    }
                    else if(row.grievanceStatusID == 1){
                        return `FHR: ${row.fhrPIC} PIC: ${row.grievancePIC}`
                    }
                    else if(row.grievanceStatusID == 3){
                        return `FHR: ${row.closedByName} PIC: ${row.updatedByName}`
                    }
                    else if(row.grievanceStatusID == 5 && row.grievanceStatusName == "Rejected"){
                        return `PIC: ${row.grievancePIC}`
                    }
                    else if(row.grievanceStatusID == 5 && row.grievanceStatusName == "Open"){
                        return `FHR: ${row.fhrPIC} PIC: ${row.grievancePIC}`
                    }
                    else if(row.grievanceStatusID == 6){
                        return `FHR: ${row.fhrPIC}`
                    }
                }
                else if (row.fhrPIC){
                    if(row.grievanceStatusID == 3){
                        return `FHR: ${row.closedByName}`
                    }
                    else{
                        return `FHR: ${row.fhrPIC}`
                    }
                }
                else if (row.grievancePIC){
                    if(row.grievanceStatusID == 3){
                        return `PIC: ${row.closedByName}`
                    }
                    else{
                        return `PIC: ${row.grievancePIC}`
                    }
                }
            },
            csvFormatter: (cell,row) => {
                if(row.fhrPIC && row.grievancePIC){
                    if(row.grievanceStatusID == 2){
                        return `FHR: ${row.fhrPIC}`
                    }
                    else if(row.grievanceStatusID == 4){
                        return `PIC: ${row.grievancePIC}`
                    }
                    else if(row.grievanceStatusID == 1){
                        return `FHR: ${row.fhrPIC} PIC: ${row.grievancePIC}`
                    }
                    else if(row.grievanceStatusID == 3){
                        return `FHR: ${row.closedByName} PIC: ${row.updatedByName}`
                    }
                    else if(row.grievanceStatusID == 5 && row.grievanceStatusName == "Rejected"){
                        return `PIC: ${row.grievancePIC}`
                    }
                    else if(row.grievanceStatusID == 5 && row.grievanceStatusName == "Open"){
                        return `FHR: ${row.fhrPIC} PIC: ${row.grievancePIC}`
                    }
                    else if(row.grievanceStatusID == 6){
                        return `FHR: ${row.fhrPIC}`
                    }
                }
                else if (row.fhrPIC){
                    if(row.grievanceStatusID == 3){
                        return `FHR: ${row.closedByName}`
                    }
                    else{
                        return `FHR: ${row.fhrPIC}`
                    }
                }
                else if (row.grievancePIC){
                    if(row.grievanceStatusID == 3){
                        return `PIC: ${row.closedByName}`
                    }
                    else{
                        return `PIC: ${row.grievancePIC}`
                    }
                }
            },
            headerAttrs: { width: 200 },
            attrs: { width: 200},
        },
        { 
            dataField: 'grievanceStatusName', 
            text: 'Status', 
            sort: true,
            headerStyle: { textAlign: 'center' }, 
            style: { textAlign: 'center', cursor: 'pointer' },
            filter: textFilter(),
            filterRenderer: (filter) => {
                statusfilter = filter;
                return null;
            },
            headerAttrs: { width: 80 },
            attrs: { width: 80},
        },
        { 
            dataField: 'updatedDate', 
            text: '', 
            csvText: 'Grievance PIC Time Stamp',
            headerStyle: { display: 'none' }, 
            style: { display: 'none' },
            csvFormatter: (cell,row) => {
                if (row.userType == 1){
                    if(row.closedDate){
                        return `${moment(row.closedDate).format('DD/MM/YYYY HH:mm:ss')}`
                    }
                    else{
                        if(row.updatedDate){
                            return `${moment(row.updatedDate).format('DD/MM/YYYY HH:mm:ss')}`   
                        }
                        else{
                            return `${row.updatedDate}`
                        }
                    }
                }
                else if(row.userType == 2){
                    if(row.updatedDate){
                        return `${moment(row.updatedDate).format('DD/MM/YYYY HH:mm:ss')}`   
                    }
                    else{
                        return `${row.updatedDate}`
                    }
                }
            },
        },
        { 
            dataField: 'closedDate', 
            text: '', 
            csvText: 'FHR Time Stamp',
            headerStyle: { display: 'none' }, 
            style: { display: 'none' },
            csvFormatter: (cell,row) => {
                if (row.userType == 2){
                    if(row.closedDate){
                        return `${moment(row.closedDate).format('DD/MM/YYYY HH:mm:ss')}`
                    }
                    else{
                        if(row.validatedDate){
                            return `${moment(row.validatedDate).format('DD/MM/YYYY HH:mm:ss')}`   
                        }
                        else{
                            return `${row.validatedDate}`
                        }
                    }
                }
                else if(row.userType == 1){
                    if(row.validatedDate){
                        return `${moment(row.validatedDate).format('DD/MM/YYYY HH:mm:ss')}`   
                    }
                    else{
                        return `${row.validatedDate}`
                    }
                }
            },
        },
        { 
            dataField: 'SLA', 
            text: 'SLA (days)', 
            headerAttrs: { width: 80 },
            attrs: { width: 80},
            sort: true,
            sortFunc: (a, b, order, dataField, rowA, rowB) => { 
                if (order === 'asc')
                {
                  return parseInt(a) - parseInt(b)
                }
               else if (order === 'desc') {
                  return  parseInt(b) - parseInt(a) 
                }
            },
            headerStyle: { textAlign: 'center' }, 
            style: { textAlign: 'center', cursor: 'pointer' },
        },
        { 
            dataField: 'SLAStatus', 
            text: 'SLA Status', 
            headerAttrs: { width: 100 },
            attrs: { width: 100},
            sort: true,
            headerStyle: { textAlign: 'center' }, 
            style: { textAlign: 'center', cursor: 'pointer' },
        }
    ] 

    const defaultSorted = [{
        dataField: 'grievanceStatusName',
        order: 'desc'
      }];
    
    const history = useHistory();

    const rowEvents = {
        onClick: (e, row) => {
            history.push(`/grievance/grievanceform/${row.grievanceID}`);
        },
      };

    const handleChangeStatus = (selectedStatusOption) => {
        if(selectedStatusOption){
            statusfilter(selectedStatusOption.value);
        }
        else{
            statusfilter("");
        }
    };

    const handleChangePriority = (selectedPriorityOption) => {
        if(selectedPriorityOption){
            priorityfiltergrievance(selectedPriorityOption.value);
        }
        else{
            priorityfiltergrievance("");
        }
    };

    const handleChangeCategory = (selectedCategoryOption) => {
        if(selectedCategoryOption){
            categoryfilter(selectedCategoryOption.value);
        }
        else{
            categoryfilter("");
        }
    };

    useEffect(() => {
        statusfilter("Open");
        setDefaultFromDate('2022-01-01');
        setDefaultToDate(moment().format('YYYY-MM-DD'));
        setChangeFromDate('2022-01-01');
        setChangeToDate(moment().format('YYYY-MM-DD'));
    }, []);

    useEffect(() => {
        let filtergrievancelist = [];
        const fromDate = new Date(moment(defaultFromDate).format('MM/DD/YYYY'));

        for (let i = 0; i < grievances.length; i++) {
            const thisDate = new Date(moment(grievances[i].createdDate).format('MM/DD/YYYY'));
            if(thisDate >= fromDate){
                filtergrievancelist.push(grievances[i]);
            }
        }
        setGrievancesCopy(filtergrievancelist)
        setGrievancesCopyFromDate(filtergrievancelist);
        setGrievancesCopyFromDate2(filtergrievancelist);
        setfromDate(true);
        setDefaultFromDateReady(filtergrievancelist);
    }, [defaultFromDate]);

    useEffect(() => {
        let filtergrievancelist = [];
        let filtergrievancelist2 = [];
        const toDate = new Date(moment(defaultToDate).format('MM/DD/YYYY'));

        for (let i = 0; i < grievancesCopyFromDate.length; i++) {
            const thisDate = new Date(moment(grievancesCopyFromDate[i].createdDate).format('MM/DD/YYYY'));
            if(thisDate <= toDate){
                filtergrievancelist.push(grievancesCopyFromDate[i]);
            }
        }
        for (let i = 0; i < grievances.length; i++) {
            const thisDate = new Date(moment(grievances[i].createdDate).format('MM/DD/YYYY'));
            if(thisDate <= toDate){
                filtergrievancelist2.push(grievances[i]);
            }
        }
        setGrievancesCopy(filtergrievancelist)
        setGrievancesCopyToDate(filtergrievancelist);
        setGrievancesCopyToDate2(filtergrievancelist2);
        settoDate(true);
    }, [defaultFromDateReady]);

    const fromdate = (e) => {
        setChangeFromDate(e.target.value);  
        if(e.target.value){
            if(toDate && fromDate){
                // console.log("1")
                let filtergrievancelist = [];
                let filtergrievancelist2 = [];
                const fromDate = new Date(moment(e.target.value).format('MM/DD/YYYY'));

                for (let i = 0; i < grievancesCopyToDate2.length; i++) {
                    const thisDate = new Date(moment(grievancesCopyToDate2[i].createdDate).format('MM/DD/YYYY'));
                    if(thisDate >= fromDate){
                        filtergrievancelist.push(grievancesCopyToDate2[i]);
                    }
                }
                for (let i = 0; i < grievances.length; i++) {
                    const thisDate = new Date(moment(grievances[i].createdDate).format('MM/DD/YYYY'));
                    if(thisDate >= fromDate){
                        filtergrievancelist2.push(grievances[i]);
                    }
                }
                setGrievancesCopy(filtergrievancelist)
                setGrievancesCopyFromDate(filtergrievancelist);
                setGrievancesCopyFromDate2(filtergrievancelist2);
                setfromDate(true);
            }
            else if(toDate){
                // console.log("2")
                let filtergrievancelist = [];
                let filtergrievancelist2 = [];
                const fromDate = new Date(moment(e.target.value).format('MM/DD/YYYY'));

                for (let i = 0; i < grievancesCopyToDate.length; i++) {
                    const thisDate = new Date(moment(grievancesCopyToDate[i].createdDate).format('MM/DD/YYYY'));
                    if(thisDate >= fromDate){
                        filtergrievancelist.push(grievancesCopyToDate[i]);
                    }
                }
                for (let i = 0; i < grievances.length; i++) {
                    const thisDate = new Date(moment(grievances[i].createdDate).format('MM/DD/YYYY'));
                    if(thisDate >= fromDate){
                        filtergrievancelist2.push(grievances[i]);
                    }
                }
                setGrievancesCopy(filtergrievancelist)
                setGrievancesCopyFromDate(filtergrievancelist);
                setGrievancesCopyFromDate2(filtergrievancelist2);
                setfromDate(true);
            }
            else{
                let filtergrievancelist = [];
                const fromDate = new Date(moment(e.target.value).format('MM/DD/YYYY'));

                for (let i = 0; i < grievances.length; i++) {
                    const thisDate = new Date(moment(grievances[i].createdDate).format('MM/DD/YYYY'));
                    if(thisDate >= fromDate){
                        filtergrievancelist.push(grievances[i]);
                    }
                }
                setGrievancesCopy(filtergrievancelist)
                setGrievancesCopyFromDate(filtergrievancelist);
                setGrievancesCopyFromDate2(filtergrievancelist);
                setfromDate(true);
            }
        }
        else{
            if(toDate){
                setGrievancesCopy(grievancesCopyToDate2);
                setGrievancesCopyFromDate([]);
                setGrievancesCopyFromDate2([]);
                setfromDate(false);
            }
            else{
                setGrievancesCopy(grievances);
                setGrievancesCopyFromDate([]);
                setGrievancesCopyFromDate2([]);
                setfromDate(false);
            }
        }
    };

    const todate = (e) => {
        setChangeToDate(e.target.value);
        if(e.target.value){
            if(toDate && fromDate){
                let filtergrievancelist = [];
                let filtergrievancelist2 = [];
                const toDate = new Date(moment(e.target.value).format('MM/DD/YYYY'));
                // console.log(fromDate);
                // console.log(thisDate>fromDate && thisDate<toDate)
                for (let i = 0; i < grievancesCopyFromDate2.length; i++) {
                    const thisDate = new Date(moment(grievancesCopyFromDate2[i].createdDate).format('MM/DD/YYYY'));
                    if(thisDate <= toDate){
                        filtergrievancelist.push(grievancesCopyFromDate2[i]);
                    }
                }
                for (let i = 0; i < grievances.length; i++) {
                    const thisDate = new Date(moment(grievances[i].createdDate).format('MM/DD/YYYY'));
                    if(thisDate <= toDate){
                        filtergrievancelist2.push(grievances[i]);
                    }
                }
                setGrievancesCopy(filtergrievancelist)
                setGrievancesCopyToDate(filtergrievancelist);
                setGrievancesCopyToDate2(filtergrievancelist2);
                settoDate(true);
            }
            else if(fromDate){
                let filtergrievancelist = [];
                let filtergrievancelist2 = [];
                const toDate = new Date(moment(e.target.value).format('MM/DD/YYYY'));

                for (let i = 0; i < grievancesCopyFromDate.length; i++) {
                    const thisDate = new Date(moment(grievancesCopyFromDate[i].createdDate).format('MM/DD/YYYY'));
                    if(thisDate <= toDate){
                        filtergrievancelist.push(grievancesCopyFromDate[i]);
                    }
                }
                for (let i = 0; i < grievances.length; i++) {
                    const thisDate = new Date(moment(grievances[i].createdDate).format('MM/DD/YYYY'));
                    if(thisDate <= toDate){
                        filtergrievancelist2.push(grievances[i]);
                    }
                }
                setGrievancesCopy(filtergrievancelist)
                setGrievancesCopyToDate(filtergrievancelist);
                setGrievancesCopyToDate2(filtergrievancelist2);
                settoDate(true);
            }
            else{
                let filtergrievancelist = [];
                const toDate = new Date(moment(e.target.value).format('MM/DD/YYYY'));

                for (let i = 0; i < grievances.length; i++) {
                    const thisDate = new Date(moment(grievances[i].createdDate).format('MM/DD/YYYY'));
                    if(thisDate <= toDate){
                        filtergrievancelist.push(grievances[i]);
                    }
                }
                setGrievancesCopy(filtergrievancelist)
                setGrievancesCopyToDate(filtergrievancelist);
                setGrievancesCopyToDate2(filtergrievancelist);
                settoDate(true);
            }
        }
        else{
            if(fromDate){
                setGrievancesCopy(grievancesCopyFromDate2);
                setGrievancesCopyToDate([]);
                setGrievancesCopyToDate2([]);
                settoDate(false);
            }
            else{
                setGrievancesCopy(grievances);
                setGrievancesCopyToDate([]);
                setGrievancesCopyToDate2([]);
                settoDate(false);
            }
        }
    };

    const paginationoption = {
        sizePerPage: 50,
    };

    const rowStyle = (row) => {
    const style = {};
    if (row.SLAStatus == "Overdue") {
        style.color = 'red';
    } 
    return style;
    };


    const { SearchBar, ClearSearchButton } = Search;

    const { ToggleList } = ColumnToggle;

    const ExportCSVButton = (props) => {
        const handleClick = () => {
            props.onExport();
        };

        return (
            <Button 
                variant='success' 
                onClick={handleClick} 
                style={{ float: 'right'}}
            >
                Export to CSV
            </Button>
        );
    };
    
    return (
        <Fragment>
            <ToolkitProvider
                keyField='id'
                data={grievancesCopy}
                columns={columns}
                columnToggle
                search={ { searchFormatted: true } }
                exportCSV={{
                    fileName: 'Worker Performance Grading Report.csv',
                    onlyExportFiltered: true, exportAll: false
                }}
            >
            {
                props => (
                <div style={{marginTop: '10px'}}>
                    <SearchBar { ...props.searchProps } />
                    <ClearSearchButton { ...props.searchProps } />
                    <ExportCSVButton { ...props.csvProps } />
                    <hr />
                    <div><strong>Filter Options</strong></div>
                    <div style={{display: 'flex'}}>
                        <Select
                            className='selectstatus'
                            placeholder={'Filter Status'}
                            onChange={handleChangeStatus}
                            defaultValue={{ label: "Open", value: "Open" }}
                            options={optionStatus}
                            isClearable
                        />
                        <Select
                            className='selectstatus'
                            placeholder={'Filter Priority'}
                            onChange={handleChangePriority}
                            options={optionPriority}
                            isClearable
                        />
                        <Select
                            className='selectstatus'
                            placeholder={'Filter Category'}
                            onChange={handleChangeCategory}
                            options={optionCategory}
                            isClearable
                        />
                        <div className='filtergrievancedate'>Filter Date From: </div>
                        <input className="filtergrievancedateinput" type="date" value={changeFromDate} onChange={fromdate}/>
                        <div className='filtergrievancedate'>To:</div>
                        <input className="filtergrievancedateinput" type="date" value={changeToDate} onChange={todate}/>
                    </div>
                    <div style={{marginTop: '20px'}}><strong>Display Options</strong></div>
                    <ToggleList
                        contextual='grievance-primary'
                        btnClassName='grievance-toggle-column-btn-custom-class'
                        { ...props.columnToggleProps } 
                    />
                    <BootstrapTable
                        classes='qrevent-table'
                        bordered={false}
                        { ...props.baseProps }
                        pagination={paginationFactory(paginationoption)}
                        headerWrapperClasses='infohub-header'
                        noDataIndication='List is empty.'
                        filter={ filterFactory() }
                        rowEvents={ rowEvents }
                        defaultSorted={ defaultSorted } 
                        rowStyle={ rowStyle }
                    />
                </div>
                )
            }
            </ToolkitProvider>
        </Fragment>
    );
};

export default GrievanceList;
